import React from 'react';
import TwitchDropItem from './TwitchDropItem';
import './TwitchDropList.scss';
// import {simpleNotification} from "../../utils/notifications";
import {Link} from "react-router";

class TwitchDropList extends React.Component {
  constructor(props) {
    super(props);
    const { games } = props;

    this.state = {
      // 初始化时保存传入的游戏数据
      gameList: games || [],
      //currentPage: parseInt(current, 10) || 1,
      isLoadingMore: false,
      //hasMore: (parseInt(current, 10) || 1) < parseInt(total, 10),
    };

    // 创建对底部加载指示器的引用
   // this.loadMoreRef = React.createRef();
  }

  componentDidMount() {
    console.log(this.props.auth,this.props.getTwitchDrops);
     const { auth: { token }  = {},getTwitchDrops} = this.props;
     getTwitchDrops(0, null, false, token, 0);
    // 创建Intersection Observer来监测底部加载指示器
    // this.observer = new IntersectionObserver(this.handleObserver, {
    //   root: null, // 使用viewport作为观察区域
    //   rootMargin: '0px',
    //   threshold: 0.1, // 当10%的元素可见时触发
    // });
    //
    // // 开始监测底部加载指示器
    // if (this.loadMoreRef.current) {
    //   this.observer.observe(this.loadMoreRef.current);
    // }
  }

  componentDidUpdate(prevProps) {
  }

  componentWillUnmount() {
    // 组件卸载时，取消观察者
    // if (this.observer) {
    //   this.observer.disconnect();
    // }
  }

  handleObserver = (entries) => {
    const entry = entries[0];
    // 当加载指示器可见且有更多数据可加载时，加载更多
    if (entry.isIntersecting && this.state.hasMore && !this.state.isLoadingMore && this.props.listStyle === 'past') {
      this.loadMore();
    }
  };

  loadMore = () => {
    const nextPage = parseInt(this.state.currentPage, 10) + 1;
    const keyword = (this.props.keyword.trim() === "") ? "" : this.props.keyword;
    // 修正参数顺序，与 handleLoadMore 期望的一致
    this.props.getUserGameList(nextPage, 'all', keyword);
    this.setState({ currentPage: nextPage });
  };

  render() {
    const { data: twitchDrops = [] } = this.props.user?.twitchDrops || { isLoading: false };
    console.log(twitchDrops);
    const {searchKeyword} = this.props;
    const fps = Object.values(twitchDrops.reduce((acc, current) => {
      const gameId = current.game.id;
        // 如果该 gameId 不存在，或者当前日期更近，则更新
        if ((!acc[gameId] ||
          current.createdAt > acc[gameId].createdAt)&&(!searchKeyword||!searchKeyword.trim()||current.game.name.toLowerCase().indexOf(searchKeyword.toLowerCase())>=0)) {
          acc[gameId] = current;
        }

        return acc;
    }, {}));

    return (
      <div className="GQL__Wrapper">
        {fps && fps.length > 0 &&
        <div className="game-quest-list">
          <div className="game-grid">
            {fps.map((game, index) => (
              <TwitchDropItem
                key={`${game.game.id}-${index}`}
                game={game.game}
                twitchDrop={game}
              />
            ))}
          </div>
        </div>
        }
        {(!fps || fps.length <= 0) &&
            <div className='no-quests'>
              There are currently no active twitch drop, please watch your email for announcements and join
              us on{" "}
              <Link rel='noopener noreferrer' target='_blank' to='https://discord.gg/Hwb2Rrg'>
                Discord
              </Link>
              .
            </div>}
      </div>
    );
  }
}

export default TwitchDropList;
